/**
 * src/components/FunnelChart.js
 * Reusable funnel visualization — horizontal bars with conversion metrics.
 */

export default function FunnelChart({ steps, definition, hasTimeMetrics }) {
  if (!steps || steps.length === 0) return null;

  const maxCount = Math.max(...steps.map(s => s.entity_count), 1);

  return (
    <div className="analytics-funnel">
      {steps.map((step, i) => {
        const barWidth = Math.max((step.entity_count / maxCount) * 100, 2);
        const dropped = i > 0 ? (steps[i - 1].entity_count - step.entity_count) : 0;

        return (
          <div key={i}>
            {/* Step bar */}
            <div className="analytics-funnel-step">
              <div className="analytics-funnel-label">
                <span>{step.label}</span>
                <span style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>{step.process_id}</span>
              </div>
              <div className="analytics-funnel-bar-container">
                <div className="analytics-funnel-bar" style={{ width: `${barWidth}%` }}>
                  <span className="analytics-funnel-count">{step.entity_count.toLocaleString()}</span>
                </div>
              </div>
            </div>

            {/* Link metrics between steps */}
            {i < steps.length - 1 && (
              <div className="analytics-funnel-link">
                <span className="analytics-funnel-arrow">↓</span>
                <span className="analytics-funnel-conversion">
                  {steps[i + 1].conversion_rate}%
                </span>
                {hasTimeMetrics && steps[i + 1].time_from_previous && (
                  <span className="analytics-funnel-time">
                    avg {steps[i + 1].time_from_previous.avg}
                  </span>
                )}
                {dropped > 0 && (
                  <span className="analytics-funnel-dropoff">
                    {dropped} dropped
                  </span>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
